import config from 'config';

export const defaultApplicationLanguage = config.default_language || 'en';

export const supportedApplicationLanguagesWithNativeTranslations = [
  { key: 'en', value: 'English', iconName: 'globe' },
  { key: 'he', value: 'עִברִית', iconName: 'globe' },
  { key: 'ar', value: 'عربى', iconName: 'globe' },
];

/**
 * Add/remove languages to add/remove language support in the app
 *
 */
export const supportedApplicationLanguages = [
  'en',
  'he',
  'ar',
];

export const rtlLanguages = [
  'he',
  'ar',
];
